import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './LayoutGallery.css';
import Layout from '../layout/Layout';
import {
  reorderArray,
  GetActivePage,
  getPages,
  hideComponent,
  getOriginalWidth,
  getOriginalHeight,
} from '../../redux/helpers/index';
import ScrollArrow from '../scroll-arrow/ScrollArrow';
import { getAutoFill } from './../../redux/helpers/getParams';
import { WEDDING } from './../../helpers/coverHelper';

class LayoutGallery extends Component {
  constructor(props) {
    super(props);
    const { bookSizes } = this.props.bookProperties;
    this.layoutRatio = getOriginalWidth(bookSizes) / getOriginalHeight(bookSizes);
    this.state = {
      displayTopArrow: false,
      displayBottomArrow: false,
      hideComponent: false,
      DEFAULT_LAYOUT_HEIGHT: 128,
      DEFAULT_LAYOUT_WIDTH: 128 * this.layoutRatio,
    };
    this.expectCover = WEDDING;
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { hideComponent } = this.state;
    const { pages } = nextProps;
    const { type: coverType } = nextProps.bookProperties.cover;
    const { isCover } = GetActivePage(pages.byId);
    const autofill = getAutoFill();

    if ((coverType === this.expectCover) && isCover) {
      this.setState({
        hideComponent: false,
      });
    }

    if (!hideComponent) {
      setTimeout(() => {
        this.toggleArrow();
      }, 0);
    }

    if (!this.state.hideComponent && !isCover && coverType === this.expectCover && autofill) {
      this.setState({
        hideComponent: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.bookProperties.bookSizes.width !== prevProps.bookProperties.bookSizes.width) {
      const { bookSizes } = this.props.bookProperties;
      this.layoutRatio = getOriginalWidth(bookSizes) / getOriginalHeight(bookSizes);
      this.setDefaultLayout();
    }
  }

  setDefaultLayout = () => {
    this.setState({
      DEFAULT_LAYOUT_HEIGHT: 128,
      DEFAULT_LAYOUT_WIDTH: this.state.DEFAULT_LAYOUT_HEIGHT * this.layoutRatio,
    });
  }

  setLayout = () => {
    const {
      pages,
      layouts,
      lang,
    } = this.props;
    const page = GetActivePage(pages.byId);

    const bookProperties = {
      isCover: 'isCover',
      isFrontFlyleaf: 'isFrontFlyleaf',
      isBackFlyleaf: 'isBackFlyleaf',
      isBabyPlaceholder: 'isBabyPlaceholder',
    };

    // Select layoiut by pageType
    const pagesLayouts = getPages(layouts);
    const reorderedArray = reorderArray(pages.byId, pagesLayouts);
    const coverLayouts = layouts.filter(cover => bookProperties.isCover in cover && !cover.only_autofill_layout);
    const flyleafFrontLayouts = layouts.filter(front => bookProperties.isFrontFlyleaf in front);
    const flyleafBackLayouts = layouts.filter(back => bookProperties.isBackFlyleaf in back);
    const BabyBookLayouts = layouts.filter(baby => bookProperties.isBabyPlaceholder in baby);

    // Load cover layout
    if (page.isCover && coverLayouts !== undefined) {
      return this.loadCoverLayouts(coverLayouts, pages, lang);
    }

    // Load front flyleaf layout
    if (page.isFrontFlyLeaf) {
      return this.loadExtraPageLayouts(flyleafFrontLayouts, pages, lang);
    }
    // Load back flyleaf layout
    if (page.isBackFlyLeaf) {
      return this.loadExtraPageLayouts(flyleafBackLayouts, pages, lang);
    }
    // Load baby layout
    if (page.isBabyPage) {
      return this.loadExtraPageLayouts(BabyBookLayouts, pages, lang);
    }

    // Default layouts
    return this.loadBelivLayouts(reorderedArray, pages, lang);
  }

  loadCoverLayouts(coverLayouts, pages, lang) {
    return coverLayouts.map((id, key) => (
      <Layout
        key={key}
        {...id}
        height={this.state.DEFAULT_LAYOUT_HEIGHT}
        width={this.state.DEFAULT_LAYOUT_HEIGHT * (id.width / id.height)}
        pages={pages.byId}
        cover
        placeholders={id.placeholders}
        lang={lang}
      />
    ));
  }

  loadBelivLayouts(reorderedArray, pages, lang) {
    return (
      reorderedArray
        ? Object.keys(reorderedArray).map((id, key) => (
          <Layout
            key={key}
            {...reorderedArray[id]}
            height={this.state.DEFAULT_LAYOUT_HEIGHT}
            width={this.state.DEFAULT_LAYOUT_WIDTH}
            pages={pages.byId}
            lang={lang}
          />))
        : 'no layout'
    );
  }

  loadExtraPageLayouts(layoutByType, pages, lang) {
    return layoutByType.map((id, key) => (
      <Layout
        key={key}
        {...id}
        height={this.state.DEFAULT_LAYOUT_HEIGHT}
        width={this.state.DEFAULT_LAYOUT_WIDTH}
        pages={pages.byId}
        lang={lang}
      />
    ));
  }


  toggleTopArrow = (visible) => {
    this.setState({
      displayTopArrow: visible,
    });
  }

  toggleBottomArrow = (visible) => {
    this.setState({
      displayBottomArrow: visible,
    });
  }

  displayArrow = (direction, target, state, className) => (
    state ?
      <ScrollArrow
        direction={direction}
        classes={`${className} galleryScroll`}
        target={target}
        vertical
      />
      :
      ''
  )

  toggleArrow = () => {
    if (!this.refs.scrollWrapper) {
      return false;
    }

    const {
      scrollLeft,
      scrollWidth,
      clientWidth,
    } = this.refs.scrollWrapper;

    if (scrollLeft > 0) {
      this.toggleTopArrow(true);
    }

    if (scrollLeft === 0) {
      this.toggleTopArrow(false);
    }

    if (scrollLeft + clientWidth === scrollWidth) {
      this.toggleBottomArrow(false);
    }

    if (scrollLeft + clientWidth !== scrollWidth) {
      this.toggleBottomArrow(true);
    }
  }

  renderLayouts = () => {
    const { hideComponent } = this.state;

    if (hideComponent) {
      return false;
    }

    return (
      <div className="scrollarea-content custom-scrollbar">
        <div className="scroll" ref="scrollWrapper" onScroll={() => this.toggleArrow()}>
          { this.setLayout()}
        </div>
      </div>
    );
  }


  render() {
    const {
      displayTopArrow,
      displayBottomArrow,
    } = this.state;

    return (
      <div className="LayoutGallery" style={{ height: 160 }}>
        { this.displayArrow('left', '.LayoutGallery .scroll', displayTopArrow, 'ScrollLeft') }
        { this.renderLayouts() }
        { this.displayArrow('right', '.LayoutGallery .scroll', displayBottomArrow, 'ScrollRight') }
      </div>
    );
  }
}

LayoutGallery.defaultProps = {
  pages: {},
  layouts: [],
  lang: {},
  bookSizes: {},
  type: 'fotos',
  cover: {},
  bookProperties: {},
};

LayoutGallery.propTypes = {
  pages: PropTypes.object,
  layouts: PropTypes.array,
  lang: PropTypes.object,
  bookSizes: PropTypes.object,
  type: PropTypes.string,
  cover: PropTypes.object,
  bookProperties: PropTypes.object,
};


export default connect(state => ({
  bookProperties: state.bookProperties,
  backgroundType: state.editorUI.bookProperties.backgroundType,
}))(LayoutGallery);



// WEBPACK FOOTER //
// ./src/components/layout-gallery/LayoutGallery.jsx